import '/app/brewery-packages/layout/grid-old/src/grid.css-raw';
export default {
  "wideOffset10": "entry-150bfe9b-wideOffset10-WXUgJq",
  "xwideOffset7": "entry-150bfe9b-xwideOffset7-WXUgJq",
  "xwideOffset2": "entry-150bfe9b-xwideOffset2-WXUgJq",
  "xwideOffset6": "entry-150bfe9b-xwideOffset6-WXUgJq",
  "tinyOffset9": "entry-150bfe9b-tinyOffset9-WXUgJq",
  "tiny8": "entry-150bfe9b-tiny8-WXUgJq",
  "wideOffset2": "entry-150bfe9b-wideOffset2-WXUgJq",
  "wideOffset6": "entry-150bfe9b-wideOffset6-WXUgJq",
  "xwideOffset11": "entry-150bfe9b-xwideOffset11-WXUgJq",
  "xwide2": "entry-150bfe9b-xwide2-WXUgJq",
  "xwide7": "entry-150bfe9b-xwide7-WXUgJq",
  "wide6": "entry-150bfe9b-wide6-WXUgJq",
  "default10": "entry-150bfe9b-default10-WXUgJq",
  "confined6": "entry-150bfe9b-confined6-WXUgJq",
  "defaultOffset5": "entry-150bfe9b-defaultOffset5-WXUgJq",
  "tiny4": "entry-150bfe9b-tiny4-WXUgJq",
  "confined4": "entry-150bfe9b-confined4-WXUgJq",
  "tinyOffset0": "entry-150bfe9b-tinyOffset0-WXUgJq",
  "tiny9": "entry-150bfe9b-tiny9-WXUgJq",
  "grid": "entry-150bfe9b-grid-WXUgJq",
  "tiny1": "entry-150bfe9b-tiny1-WXUgJq",
  "xwide11": "entry-150bfe9b-xwide11-WXUgJq",
  "confinedOffset8": "entry-150bfe9b-confinedOffset8-WXUgJq",
  "confinedOffset7": "entry-150bfe9b-confinedOffset7-WXUgJq",
  "wide9": "entry-150bfe9b-wide9-WXUgJq",
  "xwideOffset0": "entry-150bfe9b-xwideOffset0-WXUgJq",
  "xwide6": "entry-150bfe9b-xwide6-WXUgJq",
  "xwideOffset10": "entry-150bfe9b-xwideOffset10-WXUgJq",
  "defaultOffset11": "entry-150bfe9b-defaultOffset11-WXUgJq",
  "default6": "entry-150bfe9b-default6-WXUgJq",
  "confined10": "entry-150bfe9b-confined10-WXUgJq",
  "default2": "entry-150bfe9b-default2-WXUgJq",
  "col": "entry-150bfe9b-col-WXUgJq",
  "wideOffset5": "entry-150bfe9b-wideOffset5-WXUgJq",
  "tinyOffset8": "entry-150bfe9b-tinyOffset8-WXUgJq",
  "gridContainer": "entry-150bfe9b-gridContainer-WXUgJq",
  "tinyOffset6": "entry-150bfe9b-tinyOffset6-WXUgJq",
  "default8": "entry-150bfe9b-default8-WXUgJq",
  "defaultOffset9": "entry-150bfe9b-defaultOffset9-WXUgJq",
  "xwide1": "entry-150bfe9b-xwide1-WXUgJq",
  "xwideOffset9": "entry-150bfe9b-xwideOffset9-WXUgJq",
  "confinedOffset0": "entry-150bfe9b-confinedOffset0-WXUgJq",
  "tinyOffset7": "entry-150bfe9b-tinyOffset7-WXUgJq",
  "tinyOffset4": "entry-150bfe9b-tinyOffset4-WXUgJq",
  "xwide8": "entry-150bfe9b-xwide8-WXUgJq",
  "wideOffset4": "entry-150bfe9b-wideOffset4-WXUgJq",
  "tinyOffset5": "entry-150bfe9b-tinyOffset5-WXUgJq",
  "default11": "entry-150bfe9b-default11-WXUgJq",
  "xwide12": "entry-150bfe9b-xwide12-WXUgJq",
  "confined9": "entry-150bfe9b-confined9-WXUgJq",
  "tiny5": "entry-150bfe9b-tiny5-WXUgJq",
  "tiny3": "entry-150bfe9b-tiny3-WXUgJq",
  "wide7": "entry-150bfe9b-wide7-WXUgJq",
  "wide12": "entry-150bfe9b-wide12-WXUgJq",
  "confined1": "entry-150bfe9b-confined1-WXUgJq",
  "confined3": "entry-150bfe9b-confined3-WXUgJq",
  "wideOffset9": "entry-150bfe9b-wideOffset9-WXUgJq",
  "default7": "entry-150bfe9b-default7-WXUgJq",
  "standardGridContainer": "entry-150bfe9b-standardGridContainer-WXUgJq",
  "confinedOffset10": "entry-150bfe9b-confinedOffset10-WXUgJq",
  "defaultOffset1": "entry-150bfe9b-defaultOffset1-WXUgJq",
  "wideOffset0": "entry-150bfe9b-wideOffset0-WXUgJq",
  "xwide0": "entry-150bfe9b-xwide0-WXUgJq",
  "defaultOffset10": "entry-150bfe9b-defaultOffset10-WXUgJq",
  "confinedOffset2": "entry-150bfe9b-confinedOffset2-WXUgJq",
  "tiny12": "entry-150bfe9b-tiny12-WXUgJq",
  "confinedOffset3": "entry-150bfe9b-confinedOffset3-WXUgJq",
  "xwide5": "entry-150bfe9b-xwide5-WXUgJq",
  "confinedOffset9": "entry-150bfe9b-confinedOffset9-WXUgJq",
  "tinyOffset11": "entry-150bfe9b-tinyOffset11-WXUgJq",
  "wide0": "entry-150bfe9b-wide0-WXUgJq",
  "wide3": "entry-150bfe9b-wide3-WXUgJq",
  "defaultOffset3": "entry-150bfe9b-defaultOffset3-WXUgJq",
  "xwide4": "entry-150bfe9b-xwide4-WXUgJq",
  "wideOffset1": "entry-150bfe9b-wideOffset1-WXUgJq",
  "confined8": "entry-150bfe9b-confined8-WXUgJq",
  "confined2": "entry-150bfe9b-confined2-WXUgJq",
  "defaultOffset4": "entry-150bfe9b-defaultOffset4-WXUgJq",
  "tinyOffset2": "entry-150bfe9b-tinyOffset2-WXUgJq",
  "wide11": "entry-150bfe9b-wide11-WXUgJq",
  "xwideOffset5": "entry-150bfe9b-xwideOffset5-WXUgJq",
  "wide10": "entry-150bfe9b-wide10-WXUgJq",
  "confined7": "entry-150bfe9b-confined7-WXUgJq",
  "default0": "entry-150bfe9b-default0-WXUgJq",
  "default1": "entry-150bfe9b-default1-WXUgJq",
  "confinedOffset11": "entry-150bfe9b-confinedOffset11-WXUgJq",
  "confined11": "entry-150bfe9b-confined11-WXUgJq",
  "xwide3": "entry-150bfe9b-xwide3-WXUgJq",
  "default5": "entry-150bfe9b-default5-WXUgJq",
  "default9": "entry-150bfe9b-default9-WXUgJq",
  "confinedOffset5": "entry-150bfe9b-confinedOffset5-WXUgJq",
  "confined12": "entry-150bfe9b-confined12-WXUgJq",
  "wideOffset7": "entry-150bfe9b-wideOffset7-WXUgJq",
  "xwideOffset8": "entry-150bfe9b-xwideOffset8-WXUgJq",
  "default4": "entry-150bfe9b-default4-WXUgJq",
  "confinedOffset4": "entry-150bfe9b-confinedOffset4-WXUgJq",
  "row": "entry-150bfe9b-row-WXUgJq",
  "defaultOffset7": "entry-150bfe9b-defaultOffset7-WXUgJq",
  "wide2": "entry-150bfe9b-wide2-WXUgJq",
  "xwide9": "entry-150bfe9b-xwide9-WXUgJq",
  "wide8": "entry-150bfe9b-wide8-WXUgJq",
  "tiny10": "entry-150bfe9b-tiny10-WXUgJq",
  "tinyOffset1": "entry-150bfe9b-tinyOffset1-WXUgJq",
  "defaultOffset6": "entry-150bfe9b-defaultOffset6-WXUgJq",
  "wide5": "entry-150bfe9b-wide5-WXUgJq",
  "xwideOffset1": "entry-150bfe9b-xwideOffset1-WXUgJq",
  "xwideOffset4": "entry-150bfe9b-xwideOffset4-WXUgJq",
  "wideOffset8": "entry-150bfe9b-wideOffset8-WXUgJq",
  "confined0": "entry-150bfe9b-confined0-WXUgJq",
  "wide4": "entry-150bfe9b-wide4-WXUgJq",
  "defaultOffset2": "entry-150bfe9b-defaultOffset2-WXUgJq",
  "tiny6": "entry-150bfe9b-tiny6-WXUgJq",
  "default3": "entry-150bfe9b-default3-WXUgJq",
  "confined5": "entry-150bfe9b-confined5-WXUgJq",
  "confinedOffset1": "entry-150bfe9b-confinedOffset1-WXUgJq",
  "wideGridContainer": "entry-150bfe9b-wideGridContainer-WXUgJq",
  "tiny11": "entry-150bfe9b-tiny11-WXUgJq",
  "tinyOffset10": "entry-150bfe9b-tinyOffset10-WXUgJq",
  "confinedOffset6": "entry-150bfe9b-confinedOffset6-WXUgJq",
  "wide1": "entry-150bfe9b-wide1-WXUgJq",
  "xwideOffset3": "entry-150bfe9b-xwideOffset3-WXUgJq",
  "tiny0": "entry-150bfe9b-tiny0-WXUgJq",
  "tinyOffset3": "entry-150bfe9b-tinyOffset3-WXUgJq",
  "wideOffset3": "entry-150bfe9b-wideOffset3-WXUgJq",
  "armstrongGridContainer": "entry-150bfe9b-armstrongGridContainer-WXUgJq",
  "xwide10": "entry-150bfe9b-xwide10-WXUgJq",
  "defaultOffset8": "entry-150bfe9b-defaultOffset8-WXUgJq",
  "tiny2": "entry-150bfe9b-tiny2-WXUgJq",
  "default12": "entry-150bfe9b-default12-WXUgJq",
  "wideOffset11": "entry-150bfe9b-wideOffset11-WXUgJq",
  "tiny7": "entry-150bfe9b-tiny7-WXUgJq"
};